
document.addEventListener( 'DOMContentLoaded', function () {
    new Splide( '#table-slider', {
          padding     : { right: '10%' },
          perPage: 1,
          type        : 'loop',
          mediaQuery  : 'min',
          breakpoints : {
              993: {
                destroy: true,
              },
        },
      }).mount();
  });
  
  
  document.addEventListener( 'DOMContentLoaded', function () {
    new Splide( '#testimonials-slider', {
          type        : 'loop',
          mediaQuery  : 'min',
          breakpoints : {
              993: {
                  destroy: true,
              },
        },
      }).mount();
  });
  
  document.addEventListener( 'DOMContentLoaded', function () {
    new Splide( '#strike-shoes-slider', {
          type        : 'loop',
          mediaQuery  : 'min',
          breakpoints: {
            993: {
                destroy: true,
            },
          },
    }).mount();
  });

  document.addEventListener( 'DOMContentLoaded', function () {
    new Splide( '#talon-shoes-slider', {
          type        : 'loop',
          mediaQuery  : 'min',
          breakpoints: {
            993: {
                destroy: true,
            },
          },
    }).mount();
  });

  document.addEventListener( 'DOMContentLoaded', function () {
    new Splide( '#pro-boxing-shoes-slider', {
          type        : 'loop',
          mediaQuery  : 'min',
          breakpoints: {
            993: {
                destroy: true,
            },
          },
    }).mount();
  });
  